/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ManageContributionsRequestEditsInner } from './ManageContributionsRequestEditsInner';
import {
    ManageContributionsRequestEditsInnerFromJSON,
    ManageContributionsRequestEditsInnerFromJSONTyped,
    ManageContributionsRequestEditsInnerToJSON,
} from './ManageContributionsRequestEditsInner';

/**
 * 
 * @export
 * @interface ManageContributionsRequest
 */
export interface ManageContributionsRequest {
    /**
     * 
     * @type {Array<ManageContributionsRequestEditsInner>}
     * @memberof ManageContributionsRequest
     */
    edits: Array<ManageContributionsRequestEditsInner>;
}

/**
 * Check if a given object implements the ManageContributionsRequest interface.
 */
export function instanceOfManageContributionsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "edits" in value;

    return isInstance;
}

export function ManageContributionsRequestFromJSON(json: any): ManageContributionsRequest {
    return ManageContributionsRequestFromJSONTyped(json, false);
}

export function ManageContributionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManageContributionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'edits': ((json['edits'] as Array<any>).map(ManageContributionsRequestEditsInnerFromJSON)),
    };
}

export function ManageContributionsRequestToJSON(value?: ManageContributionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edits': ((value.edits as Array<any>).map(ManageContributionsRequestEditsInnerToJSON)),
    };
}

